import * as api from '@gitbook/api-client';

import { IntegrationsProvider } from './types';

/**
 * Safely parse category param passed in the URL to avoid unrelevant values.
 */
export function parseIntegrationCategoryParam(
    value: string | null | undefined
): api.IntegrationCategory | undefined {
    switch (value) {
        case api.IntegrationCategory.Analytics:
        case api.IntegrationCategory.Collaboration:
        case api.IntegrationCategory.Content:
        case api.IntegrationCategory.Gitsync:
        case api.IntegrationCategory.Marketing:
        case api.IntegrationCategory.Other:
        case api.IntegrationCategory.VisitorAuth:
            return value;
        default:
            return undefined;
    }
}

/**
 * Safely parse integrations provider param passed in the URL to avoid unrelevant values.
 */
export function parseIntegrationsProviderParam(
    value: string | null | undefined
): IntegrationsProvider | undefined {
    switch (value) {
        case IntegrationsProvider.Organization:
            return value;
        default:
            return undefined;
    }
}

/**
 * Safely parse install status param passed in the URL to avoid unrelevant values.
 */
export function parseIntegrationModalStateParam(
    value: string | null | undefined
): 'configure' | undefined {
    return value === 'configure' ? value : undefined;
}
